import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats an assign-leg pickup/dropoff time for display.
 *
 * The bound value can be either a preformatted string (initial state) or a
 * `Date` (after the assign handler converts it for the request payload).
 * A raw `Date` would render as the long `Date.toString()` and overflow the
 * field, overlapping the calendar icon, so format it back to the short
 * `MM/dd/yyyy HH:mm` form. Strings are returned unchanged.
 */
@Pipe({ name: 'assignLegTime' })
export class AssignLegTimePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(value: Date | string | null | undefined): string {
    if (value instanceof Date) {
      return this.datePipe.transform(value, 'MM/dd/yyyy HH:mm') ?? '';
    }

    return value ?? '';
  }
}
